/**
 * @author - steves165 and Andy Howell
 */

(function() {
    'use strict';

    window.supermoment = window.moment;
    // depends on moment being loaded before search-panel moment.js

    angular.module('momentjs',[])

    .factory('moment', function ($window) {
        if($window.supermoment){
            $window._thirdParty = $window._thirdParty || {};
            $window._thirdParty.moment = $window.supermoment;
            try { delete $window.supermoment; } catch (e) {$window.supermoment = undefined;}
        }
        var moment = $window._thirdParty.moment;
        return moment;
    });

    angular.module('vhols-ab-config',[])
        .constant("AB_CONST", {
            "PREFIX": "vhab."
        });

	angular.module('vhols', [
        'ui.bootstrap',
        'ngTouch',
        'ngCookies',
        'vholsLightBox',
        'vholsYoutube',
        'socialSharing',
        'vholsIframeLb',
        'vholsHeaderFooterDirectives',
        'vholsDirectivesGeneral',
        'vholsTracking',
        'vhols-ratings',
        'vhols-filters',
        'vhols-smooth-scroll',
        'vhols-destination-navbar',
        'vholsPostCodeAnywhere',
        'vhols-dates',
        'vhols-date-input',
        'vhols-date-select-list',
        'momentjs',
        'vhols-ab-config'
    ]).config(function ($locationProvider) {
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false,
            rewriteLinks: false
        });
    })
    .run(function() {
        // global IE svg shim to run first
        window.svg4everybody();
    });
})();
